/** Create Post module — locale-independent keys; labels come from i18n */

const POST_PRIVACY = {
  PUBLIC: 'public',
  BUDDIES_ONLY: 'buddies_only',
  ONLY_ME: 'only_me',
} as const;

const POST_SUGGESTED_HASHTAGS = [
  'trending',  'wlb',  'Wisdom',  'DailyMotivation',  'weightloss',
  'DailyAccountability',  'Exercise',  'HealthyEating',  'weightlossbuddy', 
  'intermittentfasting',  'Diet',  'ChangeAHabit',  'EatingHealthy',  'Accountability',
  'changeforthebetter',  'HomeWorkOut',  'HealthyDiet',  'motivation',  'Walking',
  'workout',  'ExerciseAdvice',  'HealthyRecipes',
];

/** Quick-pick chips shown on the composer card */
const POST_COMPOSER_HASHTAGS = [
  'Progress',
  'Meal',
  'Workout',
  'Support',
  'Motivation',
];

const POST_FEELINGS = [
  { key: 'motivated', emoji: '😊' },
  { key: 'makingProgress', emoji: '📈' },
  { key: 'onTrack', emoji: '🛤️' },
  { key: 'supported', emoji: '🤝' },
  { key: 'encouraged', emoji: '🙌' },
  { key: 'accountable', emoji: '✅' },
  { key: 'milestoneReached', emoji: '🏁' },
  { key: 'heard', emoji: '👂' },
  { key: 'goalCrushed', emoji: '💥' },
  { key: 'nonScaleWin', emoji: '🎉' },
  { key: 'proud', emoji: '🏆' },
  { key: 'tired', emoji: '😴' },
  { key: 'struggling', emoji: '💪' },
  { key: 'hopeful', emoji: '✨' },
  { key: 'excited', emoji: '🎉' },
  { key: 'happy', emoji: '😀' },
  { key: 'grateful', emoji: '🙏' },
  { key: 'loved', emoji: '🥰' },
  { key: 'confident', emoji: '😎' },
  { key: 'relaxed', emoji: '😌' },
  { key: 'energized', emoji: '⚡' },
  { key: 'sad', emoji: '😢' },
  { key: 'frustrated', emoji: '😤' },
  { key: 'wonderful', emoji: '🤗' },
  { key: 'blessed', emoji: '😇' },
  { key: 'thankful', emoji: '🤗' },
  { key: 'fantastic', emoji: '🤩' },
  { key: 'festive', emoji: '🥳' },
  { key: 'amused', emoji: '🙂' },
  { key: 'positive', emoji: '☀️' },
  { key: 'silly', emoji: '🤪' },
  { key: 'cool', emoji: '😎' },
  { key: 'blissful', emoji: '☺️' },
  { key: 'curious', emoji: '🤔' },
  { key: 'surprised', emoji: '😮' },
  { key: 'worried', emoji: '😟' },
  { key: 'angry', emoji: '😠' },
  { key: 'sick', emoji: '🤒' },
  { key: 'hungry', emoji: '😋' },
  { key: 'celebrating', emoji: '🎊' },
  { key: 'determined', emoji: '🎯' },
  { key: 'peaceful', emoji: '🕊️' },
  { key: 'professional', emoji: '🧐' },
  { key: 'pained', emoji: '🤕' },
  { key: 'disappointed', emoji: '😞' },
  { key: 'cold', emoji: '🥶' },
  { key: 'fabulous', emoji: '😎' },
  { key: 'sorry', emoji: '😔' },
  { key: 'bad', emoji: '🙁' },
  { key: 'inspired', emoji: '💡' },
  { key: 'pumped', emoji: '💪' },
  { key: 'optimistic', emoji: '🙂' },
  { key: 'cute', emoji: '😊' },
  { key: 'great', emoji: '😃' },
  { key: 'super', emoji: '🦸' },
  { key: 'funny', emoji: '🥸' },
  { key: 'down', emoji: '😔' },
  { key: 'satisfied', emoji: '🙂' },
  { key: 'calm', emoji: '😌' },
  { key: 'blue', emoji: '🔵' },
  { key: 'honored', emoji: '😊' },
  { key: 'unimportant', emoji: '😴' },
  { key: 'scared', emoji: '😨' },
  { key: 'wanted', emoji: '🙂' },
  { key: 'light', emoji: '🌤️' },
  { key: 'secure', emoji: '🔒' },
  { key: 'mighty', emoji: '💪' },
  { key: 'jealous', emoji: '😒' },
  { key: 'annoyed', emoji: '😒' },
  { key: 'anxious', emoji: '😰' },
  { key: 'amazed', emoji: '😲' },
  { key: 'awesome', emoji: '🤩' },
  { key: 'bored', emoji: '🥱' },
  { key: 'confused', emoji: '😕' },
  { key: 'crazy', emoji: '🤪' },
  { key: 'emotional', emoji: '🥹' },
  { key: 'fedUp', emoji: '😩' },
  { key: 'fresh', emoji: '🌱' },
  { key: 'furious', emoji: '😡' },
  { key: 'glad', emoji: '😄' },
  { key: 'heartbroken', emoji: '💔' },
  { key: 'joyful', emoji: '😁' },
  { key: 'lonely', emoji: '😔' },
  { key: 'lucky', emoji: '🍀' },
  { key: 'nervous', emoji: '😬' },
  { key: 'shocked', emoji: '😱' },
  { key: 'sleepy', emoji: '🥱' },
  { key: 'stressed', emoji: '😫' },
  { key: 'strong', emoji: '💪' },
  { key: 'upset', emoji: '😣' },
  { key: 'weak', emoji: '🫠' },
  { key: 'playful', emoji: '😜' },
  { key: 'accomplished', emoji: '🏅' },
  { key: 'proudOfMyself', emoji: '🏆' },
  { key: 'committed', emoji: '🤝' },
  { key: 'disciplined', emoji: '🎯' },
  { key: 'focused', emoji: '🧘' },
  { key: 'consistent', emoji: '🔁' },
  { key: 'active', emoji: '🏃' },
  { key: 'healthier', emoji: '💚' },
  { key: 'lighter', emoji: '🪶' },
  { key: 'victorious', emoji: '🏅' },
  { key: 'unstoppable', emoji: '🚀' },
  { key: 'resilient', emoji: '🌱' },
  { key: 'patient', emoji: '⏳' },
  { key: 'mindful', emoji: '🧘' },
  { key: 'balanced', emoji: '⚖️' },
  { key: 'connected', emoji: '🫶' },
  { key: 'understood', emoji: '💬' },
  { key: 'caredFor', emoji: '💞' },
  { key: 'accepted', emoji: '🤗' },
  { key: 'notAlone', emoji: '👥' },
  { key: 'tempted', emoji: '🍰' },
  { key: 'craving', emoji: '😋' },
  { key: 'discouraged', emoji: '😔' },
  { key: 'stuck', emoji: '🧱' },
  { key: 'overwhelmed', emoji: '😵‍💫' },
  { key: 'sore', emoji: '🩹' },
  { key: 'exhausted', emoji: '😮‍💨' },
  { key: 'restarting', emoji: '🔄' },
  { key: 'missing', emoji: '🥺' },
  { key: 'sarcastic', emoji: '😏' },
  { key: 'goofy', emoji: '🤪' },
  { key: 'good', emoji: '🙂' },
  { key: 'concerned', emoji: '😟' },
  { key: 'special', emoji: '🌟' },
  { key: 'jolly', emoji: '😄' },
  { key: 'low', emoji: '😞' },
  { key: 'broken', emoji: '💔' },
  { key: 'amazing', emoji: '🤩' },
  { key: 'welcome', emoji: '👋' },
  { key: 'beautiful', emoji: '🌸' },
  { key: 'irritated', emoji: '😣' },
];

/**
 * Product limit for post bodies. The API exposes BodyText as an unrestricted
 * string and the database column supports MAX; keep a bounded client limit so
 * long-form posts remain practical to render, moderate, and transmit.
 */
const POST_MAX_CHAR_COUNT = 2_000;
const POST_MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
const POST_MAX_VIDEO_SIZE_BYTES = 50 * 1024 * 1024;

/** Gallery posts allow 2–6 independent images. */
const POST_GALLERY_MIN_IMAGES = 2;
const POST_GALLERY_MAX_IMAGES = 6;

const POST_MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  GIF: 'gif',
} as const;

/**
 * Image post layouts — matches FileUpload ContentType values from the API:
 * Single | Gallery | Comparison2 | Comparison4
 */
const POST_IMAGE_LAYOUT = {
  SINGLE: 'Single',
  GALLERY: 'Gallery',
  COMPARISON_2: 'Comparison2',
  COMPARISON_4: 'Comparison4',
} as const;

const POST_IMAGE_LAYOUT_SLOT_COUNT = {
  [POST_IMAGE_LAYOUT.SINGLE]: 1,
  [POST_IMAGE_LAYOUT.GALLERY]: 0,
  [POST_IMAGE_LAYOUT.COMPARISON_2]: 2,
  [POST_IMAGE_LAYOUT.COMPARISON_4]: 4,
} as const;

const SUPPORTED_VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/x-m4v',
  'video/mpeg',
];

/**
 * Formats the post API stores. Anything else (AVIF, HEIC/HEIF, TIFF …) is
 * refused server-side with "media doesn't match content type", so pickers
 * filter these out before the file reaches the composer.
 */
const SUPPORTED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/gif',
  'image/webp',
];

const SUPPORTED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'jfif', 'png', 'gif', 'webp'];

/**
 * Accepts a picked image when its MIME type is supported, falling back to the
 * extension for the pickers that report an empty type.
 */
const isSupportedImageFormat = (mimeType?: string | null, fileName?: string | null): boolean => {
  const mime = (mimeType || '').toLowerCase().trim();
  if (mime) {
    return SUPPORTED_IMAGE_MIME_TYPES.includes(mime);
  }
  const extension = (fileName || '').toLowerCase().split('.').pop() || '';
  return SUPPORTED_IMAGE_EXTENSIONS.includes(extension);
};

export {
  POST_PRIVACY,
  POST_SUGGESTED_HASHTAGS,
  POST_COMPOSER_HASHTAGS,
  POST_FEELINGS,
  POST_MAX_CHAR_COUNT,
  POST_MAX_IMAGE_SIZE_BYTES,
  POST_MAX_VIDEO_SIZE_BYTES,
  POST_GALLERY_MIN_IMAGES,
  POST_GALLERY_MAX_IMAGES,
  POST_MEDIA_TYPE,
  POST_IMAGE_LAYOUT,
  POST_IMAGE_LAYOUT_SLOT_COUNT,
  SUPPORTED_VIDEO_MIME_TYPES,
  SUPPORTED_IMAGE_MIME_TYPES,
  SUPPORTED_IMAGE_EXTENSIONS,
  isSupportedImageFormat,
};
